import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../common/others/SharedDispatcher";
import _ from "underscore";
import "../../../../../Assets/javascripts/common/others/jquery.validate.unobtrusive.extensions.js"

export default Backbone.View.extend({

    options: {

        // - Main selector
        //
        'target': 'form',
        'normalizeCheckbox': true,
        'hasBlurValidation': true
    },

    selectors: {
        text: '.js-form-input',
        select: '.js-form-select',
        password: '.js-input-password',
        checkbox: '.js-input-checkbox'
    },

    events: {
        "blur .js-form-input": "onInputBlur",
        "change .js-form-input": "onAutofill",
        "blur .js-input-password": "onInputBlur",
        "change .js-input-checkbox": "onCheckboxChange",
        "change .js-form-select": "onSelectChange",
        "submit": "onSubmit"
    },

    initialize: function (opts) {

        _.extend(this.options, opts);

        $.validator.unobtrusive.parse($(this.options.target));

        this.setElement(this.options.target);

        var self = this;

        $(this.selectors.checkbox).each(function () {

            self._normalizeCheckboxValue($(this));
        });

        $(this.selectors.select).each(function () {

            self._appendSelectValue($(this));
        });

        this._validateNonEmptyFields();
    },

    // - Events
    //
    onCheckboxChange: function (evt) {

        if (this.options.normalizeCheckbox === true) {

            var $element = $(evt.target);

            var self = this;

            if ($element.is('input[type="radio"]')) {

                var groupName = $element.attr('name');

                $('input[type="radio"][name="' + groupName + '"]').each(function (i, el) {
                     
                    self._normalizeCheckboxValue($(el));
                });

            }
            else {
                this._normalizeCheckboxValue($element);
            }

            
        }
    },

    onSelectChange: function (evt) {

        this._appendSelectValue($(evt.target));
    },

    // - Force input validation on blur 
    //
    onInputBlur: function (evt) {

        var $element = $(evt.target);

        this._setAsFilled($element);

        if (this.options.hasBlurValidation === true) {

            $($element).valid();
        }
    },

    onSubmit: function (evt) {

        var self = this;

        this.$el.find(this.selectors.password).each(function () {

            self._ensurePasswordVisibility($(this));
        });

      SharedDispatcher.trigger("addressesform:submit");
      SharedDispatcher.trigger("registrationform:submit");
    },


    onAutofill: function (evt) {

        var $target = $(evt.target);
        var autocompleteAttr = $target.attr('autocomplete');

        if (autocompleteAttr && autocompleteAttr != 'off') {

            this._setAsFilled($target);

            $target.valid();
        }
    },

    _appendSelectValue: function (element) {

        element.attr('value', element.children(':selected').val());
    },

    _setAsFilled: function (element) {

        var val = element.val();

        if (val && val.length > 0) {

            element.addClass('filled');
        } else {
            element.removeClass('filled');
        }
    },

    // - Ensure that passwords aren't visible 
    //
    _ensurePasswordVisibility: function (element) {

        element.attr('type', 'password');
    },

    // - Used to set checkbox value to True/False
    //
    _normalizeCheckboxValue: function (checkbox) {

        if (!checkbox && checkbox.length == 0) {
            return;
        }

        if (checkbox.is(':checked')) {

            checkbox.val('True');
        }
        else {
            checkbox.val('False');
        }
    },

    _validateNonEmptyFields: function () {

        var self = this;

        $(this.selectors.text).each(function () {

            self._setAsFilled($(this));

            if ($(this).val().length > 0) {

                $(this).valid();
            }
        });
    }

});
